(function($){
    // var timer;
    // $('wp-block-search__button-inside input').keyup(function() {
    //     clearTimeout(timer);
    //     var val = $(this).val();
    //     timer = setTimeout(function() {
    //         legia_ajax_search(val);
    //     }, 800);
    // });
    var typingTimer;
    var doneTypingInterval = 500; // Czas opóźnienia w milisekundach

    $('.wp-block-search__button-inside input').on('keyup', function() {
        clearTimeout(typingTimer);
        var th = $(this);
        typingTimer = setTimeout(function() {
            legia_ajax_search(th.val());
        }, doneTypingInterval);
    });

    $('.wp-block-search__button-inside input').on('keydown', function() {
        clearTimeout(typingTimer);
    });


    $('.wp-block-search__button-inside input').on('focusin', function(){
        legia_ajax_search($(this).val());
    });

    function legia_ajax_search(val){
        $('.ajax-result').remove();
        $('.search-loader').remove();
        $.ajax({
            url: script.ajax_url,
            method: 'post',
            data: {
                'action': 'legia_ajax_search',
                'val': val,
                'nonce': script.nonce
            },
            beforeSend: function(){
                $('.wp-block-search__button-inside').append('<img src="'+$('body').attr('data-loader')+'" class="search-loader" />');
            },
            success: function (data) {
                $('.search-loader').remove();
                $('.ajax-result').remove();
                $('header [role="search"]').append(data);
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    $('body').on('click', '.ajax-result .hide-results', function(e){
        e.preventDefault();
        $('.ajax-result').remove();
        $('.wp-block-search__button-inside input').val('');
    });
    $('body').on('click', '*', function(){

        if($(this).closest('.ajax-result').length > 0){

        }
        else{

        }
    })
    var mouse_is_inside = false;
    $(document).ready(function(){
        $('.wp-block-search__button-inside input').attr('autocomplete', 'off');
        $('.ajax-result, .wp-block-search__button-inside input').hover(function(){
            mouse_is_inside=true;
        }, function(){
            mouse_is_inside=false;
        });

        $("body").mouseup(function(){
            if(! mouse_is_inside) $('.ajax-result').hide();
        });
    })

})(jQuery)